import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { FaEye, FaCheckCircle, FaArrowUp, FaArrowDown } from 'react-icons/fa';
import CategorySelect from './CategorySelect';
import { formatGainPct, gainClass } from '../utils/gainFormat';
import { getVcpDisplay } from '../utils/vcpFormat';

// Renders one VCP list row exactly as it appears on the VCP page. Shared by
// VCP.js (the source page) and TickerSearch.js so both places stay in sync.
const VcpRow = ({
  item,
  index,
  selected,
  highlighted,
  removing,
  deleting,
  globalPriceUpdateLoading,
  onRowClick,
  onEditVcp,
  onPriceUpdateToggle,
  onCategoryUpdate,
  onPromote,
  onDemote,
}) => {
  return (
    <tr
      className={`leaders-row${selected ? ' leaders-row-selected' : ''}${highlighted ? ' leaders-row-highlight' : ''}${removing ? ' leaders-row-removing' : ''}`}
      onClick={() => onRowClick(item.id)}
      style={{ cursor: 'pointer' }}
    >
      <td className="text-center" style={{ width: '40px', fontSize: '0.85rem', color: '#888' }}>{index + 1}</td>
      <td style={{ width: '60px' }}>{item.ticker}</td>
      <td className="text-center" style={{ width: '80px', fontSize: '0.75rem' }}>
        {item.latest_note_updated_at ? (() => {
          const noteDate = new Date(item.latest_note_updated_at);
          const today = new Date();
          const isToday = noteDate.toDateString() === today.toDateString();
          const timeStr = noteDate.toLocaleDateString('en-US', {
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: false
          }).replace(',', '');

          return isToday ? (
            <span className="badge bg-success" style={{ fontSize: '0.7rem', fontWeight: 'normal' }}>
              {timeStr}
            </span>
          ) : timeStr;
        })() : '-'}
      </td>
      <td className="text-center" style={{ width: '120px' }} onClick={e => e.stopPropagation()}>
        <button
          type="button"
          className="btn btn-link p-0"
          onClick={(e) => {
            e.stopPropagation();
            onEditVcp(item);
          }}
          title="Edit VCP details"
        >
          {getVcpDisplay(item)}
        </button>
      </td>
      <td className="text-end" style={{ width: '60px' }}>{item.price !== undefined && item.price !== null ? `$${parseFloat(item.price).toFixed(2)}` : '-'}</td>
      <td className={`text-end ${gainClass(item.gain)}`} style={{ width: '60px' }}>{formatGainPct(item.gain_pct)}</td>
      <td className="text-center" style={{ width: '60px' }}>
        {item.is_purchased ? (
          <FaCheckCircle color="#28a745" size="1.2em" title="Owned" />
        ) : (
          <FaEye color="#007bff" size="1.2em" title="Watching" />
        )}
      </td>
      <td className="text-center" style={{ width: '90px' }} onClick={e => e.stopPropagation()}>
        <Form.Check
          type="switch"
          id={`leaders-price-toggle-${item.id}`}
          checked={item.is_purchased ? true : item.include_in_price_updates !== false}
          disabled={item.is_purchased || globalPriceUpdateLoading}
          onChange={(e) => {
            e.stopPropagation();
            onPriceUpdateToggle(item, e.target.checked);
          }}
          title={
            item.is_purchased
              ? 'Active holdings always receive price updates.'
              : 'Toggle price updates for this ticker.'
          }
        />
      </td>
      <td className="text-end" style={{ width: '172px' }}>
        <CategorySelect
          tickerId={item.id}
          currentCategory={item.category ? { category_id: item.category_id, name: item.category } : null}
          onCategoryUpdate={onCategoryUpdate}
          isVcp={true}
        />
      </td>
      <td className="text-end align-middle" style={{ width: '180px' }} onClick={e => e.stopPropagation()}>
        <Button
          variant="outline-success"
          size="sm"
          className="btn-sm me-1"
          style={{ padding: '2px 6px', fontSize: '0.75rem', border: '1px solid #28a745', backgroundColor: 'transparent' }}
          onClick={() => onPromote(item.id)}
          disabled={deleting}
          title="Promote to Watchlist"
        >
          {deleting ? (
            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
          ) : (
            <FaArrowUp size="0.8em" />
          )}
        </Button>
        <Button
          variant="outline-info"
          size="sm"
          className="btn-sm me-1"
          style={{ padding: '2px 6px', fontSize: '0.75rem', border: '1px solid #17a2b8', backgroundColor: 'transparent' }}
          onClick={() => onDemote(item.id)}
          disabled={deleting}
          title="Demote to Basing"
        >
          {deleting ? (
            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
          ) : (
            <FaArrowDown size="0.8em" />
          )}
        </Button>
      </td>
    </tr>
  );
};

export default VcpRow;
